import { memo, ReactNode } from "react";
import { useDelayHint } from "../../../../utils";
import Loader from "../Loader";

export type LoaderContainerProps = {
  isLoading?: boolean,
  loaderClassName?: string,
  delayHint?: number
  children: ReactNode
}

export const LoaderContainer = memo<LoaderContainerProps>((
  {
    isLoading,
    delayHint,
    loaderClassName,
    children,
  }) => {
  const showLoader = useDelayHint(isLoading || false, delayHint || 0);
  return (
    <>
      {showLoader ? <Loader className={loaderClassName} /> : children}
    </>
  );
});

export default LoaderContainer;
